import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import { timeObjectFromMinutes } from '../../../utilities/time';

const Shift = ({ className, mins, timeIn, displaytime, color, projectName }) => {
    const formatedTimeIn = timeIn.format(timeIn.minutes() ? 'h:mA' : 'hA');
    const time = timeObjectFromMinutes(mins, false);
    return projectName ? (
        <Tooltip placement="top" trigger="hover" overlay={`${projectName}: ${time.hours}h ${time.minutes}m`} overlayClassName={'help-button-tooltip'}>
            <div className={`shift ${className}`} style={{ flex: mins, backgroundColor: color }}>
                {displaytime && <div className="timeline-hours">{formatedTimeIn}</div>}
            </div>
        </Tooltip>
    ) : (
        <div className={`shift ${className}`} style={{ flex: mins, backgroundColor: color }}>
            {displaytime && <div className="timeline-hours">{formatedTimeIn}</div>}
        </div>
    );
};

Shift.propTypes = {
    className: PropTypes.string,
    mins: PropTypes.number,
    timeIn: PropTypes.object,
    displaytime: PropTypes.bool
};

export default Shift;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/components/shift.jsx